import React from 'react';
import { Button, Typography } from '@mui/material';
import Modal from 'components/shared/Modal';
import { ModalProps } from 'store/types/ComponentProps';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import { ConfirmationType, ItemType } from 'store/enums/BallotReviewTypes';

interface ConfirmationModalProps extends ModalProps {
  itemType: ItemType;
  confirmationType: ConfirmationType;
  loading?: boolean;
  onSubmit: () => void;
}

const confirmationTypeContent: Record<ConfirmationType, string> = {
  [ConfirmationType.Overwrite]: 'Are you sure you want to overwrite the',
  [ConfirmationType.Delete]: 'Are you sure you want to delete the',
};

const ConfirmationModal: React.FunctionComponent<ConfirmationModalProps> = ({
  open,
  itemType,
  confirmationType,
  loading,
  onClose,
  onSubmit,
}) => {
  return (
    <Modal
      title={`${confirmationType} ${itemType}`}
      open={open}
      maxWidth={'xs'}
      loading={loading}
      onClose={onClose}
      onSubmit={onSubmit}
      actions={
        <>
          <Button color={'secondary'} variant={'outlined'} disabled={loading} onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="submit"
            color={confirmationType === ConfirmationType.Delete ? 'error' : 'primary'}
            variant={'contained'}
          >
            {confirmationType}
          </Button>
        </>
      }
    >
      <GridContainer>
        <GridItem>
          <Typography>
            {confirmationTypeContent[confirmationType]} {itemType.toLowerCase()}?
          </Typography>
        </GridItem>
      </GridContainer>
    </Modal>
  );
};

export default ConfirmationModal;
